import * as React from "react";
import { DeckComponent } from "./DeckComponent";
import { IAgendaState } from "./Scenario";
import { GameToken, CardType } from "./Card";

export interface IActDeckProps {
    state: IAgendaState;
    onChanged: () => void;
}
export class AgendaDeckComponent extends React.Component<IActDeckProps, any>  {
    render() {
        const topCard = this.props.state.deck.cards[0];
        let draggable = false;
        //cannot drag agenda cards, but others...
        if (topCard.type !== CardType.Agenda) {
            draggable = true;
        }
        return (
            <div id="agendaDeck">
                <DeckComponent deck={this.props.state.deck} horizontal={true}
                    settings={{ toolbar: { navigation: true, navigationAllowedOnFaceDownCards: true }, allowedTokens: [GameToken.Doom], hideTokensOnBack: true, draggable: draggable }}
                    onChanged={() => this.props.onChanged()} />
            </div>
        );
    }
}
